"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const GtmContainer_1 = __importDefault(require("@web/common/GtmContainer"));
const ElementViewportObserver_1 = __importDefault(require("@web/common/ElementViewportObserver"));
const GtmDataLayer_1 = __importDefault(require("@react/common/GtmDataLayer/GtmDataLayer"));
(() => {
    let GaEvents;
    (function (GaEvents) {
        GaEvents["VIEW_ITEM_LIST"] = "view_item_list";
        GaEvents["SELECT_ITEM"] = "select_item";
        GaEvents["VIEW_ITEM"] = "view_item";
        GaEvents["BEGIN_CHECKOUT"] = "begin_checkout";
        GaEvents["PURCHASE"] = "purchase";
        GaEvents["PROMOTION_VIEW"] = "view_promotion";
        GaEvents["PROMOTION_SELECT"] = "select_promotion";
        GaEvents["VIDEO_TESTIMONIAL_PLAY"] = "video_testimonial_play";
        GaEvents["FAQ_OPEN"] = "faq_open";
    })(GaEvents || (GaEvents = {}));
    let GaVersion;
    (function (GaVersion) {
        GaVersion["GA4"] = "ga-4Data";
    })(GaVersion || (GaVersion = {}));
    const CZK_CURRENCY_ENUM = 'CZK';
    function getElementData(element, gaVersion) {
        const data = element.dataset[gaVersion];
        try {
            if (data) {
                return JSON.parse(data);
            }
            return null;
        }
        catch (e) {
            console.warn(`Catch getElementData error | ${e}`);
            return null;
        }
    }
    function isOpenedInNewTab(event) {
        let MouseButtonCodes;
        (function (MouseButtonCodes) {
            MouseButtonCodes[MouseButtonCodes["LEFT_BUTTON"] = 0] = "LEFT_BUTTON";
            MouseButtonCodes[MouseButtonCodes["MIDDLE_BUTTON"] = 1] = "MIDDLE_BUTTON";
            MouseButtonCodes[MouseButtonCodes["RIGHT_BUTTON"] = 2] = "RIGHT_BUTTON";
        })(MouseButtonCodes || (MouseButtonCodes = {}));
        return (event.button === MouseButtonCodes.LEFT_BUTTON && event.ctrlKey === true)
            || (event.button === MouseButtonCodes.LEFT_BUTTON && event.metaKey === true)
            || event.button === MouseButtonCodes.MIDDLE_BUTTON;
    }
    function handleCarDetailViewItem(element) {
        const productDataGa4 = getElementData(element, GaVersion.GA4);
        if (productDataGa4 === null) {
            console.error('No datalayer product data GA4: handleCarDetailView');
            return;
        }
        (0, GtmDataLayer_1.default)({
            event: GaEvents.VIEW_ITEM,
            currency: CZK_CURRENCY_ENUM,
            value: productDataGa4[0].price,
            items: productDataGa4,
        });
    }
    function pushViewItemList(element) {
        const productsDataGa4 = getElementData(element, GaVersion.GA4);
        if (productsDataGa4 === null) {
            console.error('No datalayer product data GA4: pushViewItemList');
            return;
        }
        const listName = productsDataGa4[0].list;
        (0, GtmDataLayer_1.default)({
            event: GaEvents.VIEW_ITEM_LIST,
            item_list_id: listName,
            item_list_name: listName,
            items: productsDataGa4,
        });
    }
    function pushDataLayerGa4Click(event, productData, url) {
        if (productData) {
            const listName = productData[0].list;
            (0, GtmDataLayer_1.default)({
                event: GaEvents.SELECT_ITEM,
                item_list_id: listName,
                item_list_name: listName,
                items: productData,
                eventCallback(gtmId) {
                    if (GtmContainer_1.default.isValidGtmId(gtmId)) {
                        if (isOpenedInNewTab(event) === true) {
                            window.open(url, '_blank');
                        }
                        else {
                            window.location.assign(url);
                        }
                    }
                },
                eventTimeout: 2000,
            });
        }
    }
    function handleBeginCheckout(element) {
        const productDataGa4 = getElementData(element, GaVersion.GA4);
        if (productDataGa4 === null) {
            console.error('No datalayer product data GA4: handleBeginCheckout');
            return;
        }
        (0, GtmDataLayer_1.default)({
            event: GaEvents.BEGIN_CHECKOUT,
            currency: CZK_CURRENCY_ENUM,
            value: productDataGa4[0].price,
            items: productDataGa4,
        });
    }
    function handlePurchase(element) {
        const productDataGa4 = getElementData(element, GaVersion.GA4);
        if (productDataGa4 === null) {
            console.error('No datalayer product data GA4: handlePurchase');
            return;
        }
        (0, GtmDataLayer_1.default)({
            event: GaEvents.PURCHASE,
            transaction_id: element.dataset['ga-4TransactionId'],
            value: productDataGa4[0].price,
            currency: CZK_CURRENCY_ENUM,
            items: productDataGa4,
        });
    }
    function handleViewPromotion(element) {
        const productDataGa4 = getElementData(element, GaVersion.GA4);
        if (productDataGa4 === null) {
            console.error('No datalayer product data GA4: handleViewPromotion');
            return;
        }
        (0, GtmDataLayer_1.default)({
            event: GaEvents.PROMOTION_VIEW,
            creative_name: 'abandoned_inquiry_modal',
            promotion_name: 'abandoned_inquiry_modal',
            items: productDataGa4,
        });
    }
    function handlePromotionClick(element) {
        const parent = element.parentElement;
        if (parent === null) {
            return;
        }
        const abandonedInquiryLinks = Array.from(parent.querySelectorAll('.abandoned-inquiry-car-modal-link'));
        abandonedInquiryLinks.forEach((link) => {
            link.addEventListener('click', (event) => {
                if (GtmContainer_1.default.checkGtmExist()) {
                    event.preventDefault();
                }
                const productDataGa4 = getElementData(element, GaVersion.GA4);
                if (productDataGa4 === null) {
                    console.error('No datalayer product data GA4: handlePromotionClick');
                    return;
                }
                (0, GtmDataLayer_1.default)({
                    event: GaEvents.PROMOTION_SELECT,
                    creative_name: 'abandoned_inquiry_modal',
                    promotion_name: 'abandoned_inquiry_modal',
                    items: productDataGa4,
                    eventCallback(gtmId) {
                        const url = link.getAttribute('href');
                        if (url) {
                            if (GtmContainer_1.default.isValidGtmId(gtmId)) {
                                if (isOpenedInNewTab(event)) {
                                    window.open(url, '_blank');
                                }
                                else {
                                    window.location.assign(url);
                                }
                            }
                        }
                    },
                    eventTimeout: 2000,
                });
            });
        });
    }
    function handleFaqOpen(element) {
        const parent = element.parentElement;
        if (parent === null) {
            return;
        }
        const question = parent.querySelector('.question');
        if (question) {
            question.addEventListener('click', () => {
                const title = question.querySelector('.title');
                (0, GtmDataLayer_1.default)({
                    event: GaEvents.FAQ_OPEN,
                    content: title === null || title === void 0 ? void 0 : title.innerText,
                });
            });
        }
    }
    function handleTestimonialPlay(element) {
        const parent = element.parentElement;
        if (parent === null) {
            return;
        }
        const button = parent.querySelector('.button-primary');
        if (button) {
            button.addEventListener('click', () => {
                (0, GtmDataLayer_1.default)({
                    event: GaEvents.VIDEO_TESTIMONIAL_PLAY,
                    content: button.dataset.subHtml,
                });
            });
        }
    }
    function handleElementImpressions(element) {
        ElementViewportObserver_1.default.observeElement(element, () => {
            element.classList.add('in-view');
            if (element.classList.contains('in-data-layer') === false) {
                pushViewItemList(element);
                element.classList.add('in-data-layer');
            }
        });
    }
    function handleSelectItem(element) {
        const parent = element.parentElement;
        if (parent === null) {
            return;
        }
        const links = Array.from(parent.querySelectorAll('a'));
        links.forEach((link) => {
            link.addEventListener('click', (event) => {
                if (GtmContainer_1.default.checkGtmExist()) {
                    event.preventDefault();
                }
                const url = link.getAttribute('href');
                const productDataGa4 = getElementData(element, GaVersion.GA4);
                if (productDataGa4 === null) {
                    console.error('No datalayer product data GA4: pushDataLayerClick');
                    return;
                }
                if (url) {
                    pushDataLayerGa4Click(event, productDataGa4, url);
                }
            });
        });
    }
    function initHandleGaEvents() {
        var _a;
        const gaElements = Array.from(document.querySelectorAll('*[data-component-name="GAEvent"]'));
        const isNotSubscriptionMergedList = ((_a = document
            .querySelector('.listing-item-offers-list')) === null || _a === void 0 ? void 0 : _a.classList.contains('model-listing')) === false;
        gaElements.forEach((element) => {
            var _a;
            const triggerNames = (_a = element.dataset.gaEvent) === null || _a === void 0 ? void 0 : _a.split(',');
            if (triggerNames === undefined) {
                return;
            }
            triggerNames.forEach((trigger) => {
                switch (trigger) {
                    case GaEvents.VIEW_ITEM_LIST:
                        if (isNotSubscriptionMergedList) {
                            handleElementImpressions(element);
                        }
                        break;
                    case GaEvents.SELECT_ITEM:
                        handleSelectItem(element);
                        break;
                    case GaEvents.VIEW_ITEM:
                        handleCarDetailViewItem(element);
                        break;
                    case GaEvents.BEGIN_CHECKOUT:
                        handleBeginCheckout(element);
                        break;
                    case GaEvents.PURCHASE:
                        handlePurchase(element);
                        break;
                    case GaEvents.PROMOTION_VIEW:
                        handleViewPromotion(element);
                        break;
                    case GaEvents.PROMOTION_SELECT:
                        handlePromotionClick(element);
                        break;
                    case GaEvents.VIDEO_TESTIMONIAL_PLAY:
                        handleTestimonialPlay(element);
                        break;
                    case GaEvents.FAQ_OPEN:
                        handleFaqOpen(element);
                        break;
                    default:
                        console.error('Unknown datalayer GA event');
                }
            });
        });
    }
    initHandleGaEvents();
    document.addEventListener('ReactListingOffersListLoadedEvent', () => {
        initHandleGaEvents();
    }, false);
})();
